import React, { useState } from 'react';
import { FaPencilAlt } from 'react-icons/fa';
import axios from 'axios';
import { toast } from 'react-toastify';
import BOHeader from '@/components/back-office/BOHeader';
import BONavigationButton from '@/components/back-office/BONavigationButton';
import { useRestaurantsContext } from '@/contexts/RestaurantContext';

const TopBanner = ({
	role,
	showButtons = 'both',
	showToggle,
	navigationRouteText,
	navigationRoute,
	hasTopRightButton = true,
	hasEventInfo = true,
	withDescription = true,
	hasOtherButtons = false,
	otherButtons = null,
}) => {
	const [isEditing, setIsEditing] = useState(false);
	const { selectedRestaurant } = useRestaurantsContext();
	const [newName, setNewName] = useState(selectedRestaurant.name);

	const handleNameUpdate = async () => {
		try {
			const response = await axios.patch(
				`${import.meta.env.VITE_API_URL}/api/back-office/restaurants/${selectedRestaurant.id}/update-name`,
				{ name: newName },
				{
					headers: {
						'Content-Type': 'application/json',
					},
				}
			);

			if (response.status === 200) {
				toast.success('Nom du restaurant mis à jour avec succès', {
					position: 'top-center',
					autoClose: 800,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					theme: 'colored',
				});
				setIsEditing(false);
				// Recharger la page pour mettre à jour les informations
				window.location.reload();
			}
		} catch (error) {
			console.error('Erreur lors de la mise à jour du nom:', error);
			toast.error('Erreur lors de la mise à jour du nom', {
				position: 'top-center',
				autoClose: 800,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		}
	};

	return (
		<>
			<div className="flex flex-col gap-4">
				{role && (
					<BOHeader
						instanceName={
							<div className="flex items-center gap-2">
								{isEditing ? (
									<div className="flex items-center gap-2">
										<input
											type="text"
											value={newName}
											onChange={(e) => setNewName(e.target.value)}
											className="px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
										/>
										<button
											onClick={handleNameUpdate}
											className="px-3 py-1 bg-primary text-white rounded-md hover:bg-primary-dark text-sm"
										>
											Sauvegarder
										</button>
										<button
											onClick={() => {
												setIsEditing(false);
												setNewName(selectedRestaurant.name);
											}}
											className="px-3 py-1 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 text-sm"
										>
											Annuler
										</button>
									</div>
								) : (
									<>
										<span className='capitalize'>{`${selectedRestaurant.name.replace('-', ' ')}`}</span>
										{role === 'super-admin' && (
											<button
												onClick={() => setIsEditing(true)}
												className="p-1 text-gray-600 hover:text-primary"
											>
												<FaPencilAlt size={14} />
											</button>
										)}
									</>
								)}
							</div>
						}
						hasButton={hasTopRightButton}
						navigationRoute={navigationRoute}
						text={navigationRouteText}
						selectedRestaurant={selectedRestaurant}
						showToggle={showToggle}
						withDescription={withDescription}
						hasOtherButtons={hasOtherButtons}
						otherButtons={otherButtons}
					/>
				)}

				{hasEventInfo && (
					<div className="text-sm px-4">
						<p>Nom de l'événement: <span className="capitalize">{selectedRestaurant.name.replace('-', ' ')}</span></p>
						<p>
							Date de fin:{' '}
							{selectedRestaurant.end_date
								? new Date(selectedRestaurant.end_date).toLocaleDateString('fr-FR')
								: ''}
						</p>
					</div>
				)}

				<div className="flex place-content-center gap-4">
					{['both', 'left'].includes(showButtons) && ['super-admin', 'admin'].includes(role) && !selectedRestaurant.is_no_limit && (
						<BONavigationButton
							navigationRoute={`/back-office/restaurants/${selectedRestaurant?.id}/menu`}
							text={'Gérer le menu'}
						/>
					)}

					{['both', 'right'].includes(showButtons) && ['super-admin', 'admin'].includes(role) && (
						<BONavigationButton
							navigationRoute={`/back-office/restaurants/${selectedRestaurant.id}/products`}
							text={'Gérer les produits'}
						/>
					)}
				</div>
			</div>
		</>
	);
};

export default TopBanner;
